var map = {
	"./Track_11_Story_2_Colours.mp3": "625b",
	"./s2_1.mp3": "8ee0",
	"./s2_2.mp3": "6029",
	"./s2_3.mp3": "8e21",
	"./s2_4.mp3": "c209"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "263e";